import { createUseStyles } from 'react-jss';

import { ITheme } from 'types';

const useStyles = createUseStyles((theme: ITheme) => ({
  suggestionMenu: {
    padding: theme.spacings.s16,
  },
  desktopExportButton: {
    '& *': {
      pointerEvents: 'none',
    },
  },
  downloadBottomSheetIndex: {
    zIndex: 2,
  },
}));

export default useStyles;
